const initialState = {
  isFetching: false,
  syncCount: 0,
}

const fetchStatus = (state = initialState, action) => {
  switch(action.type) {
    case 'FETCH_SYNC_SUCCESS':
    case 'FETCH_SYNC_FAILURE':
      const decreasedSyncCount = state.syncCount-1;
      return Object.assign({}, state, {
        isFetching: decreasedSyncCount > 0,
        syncCount: decreasedSyncCount,
      });
    case 'FETCH_SYNC_REQUEST':
      const increasedSyncCount = state.syncCount+1;
      return Object.assign({}, state, {
        isFetching: increasedSyncCount > 0,
        syncCount: increasedSyncCount,
      });
    default :
      return state;
  }
};

export default fetchStatus;


// WEBPACK FOOTER //
// ./src/reducers/fetch-status.js